import React, { FC } from 'react';
import Safe from 'react-safe';

export const DigicertLogo: FC = () => {
  return (
    <>
      <div className="digicert" data-language="en" id="DigiCertClickID_w1UhGEMm">{` `}</div>
      <Safe.script type="text/javascript">{`
        var __dcid = __dcid || [];__dcid.push(["DigiCertClickID_w1UhGEMm", "3", "m", "black", "w1UhGEMm"]);(function(){var cid=document.createElement("script");cid.async=true;cid.src="//seal.digicert.com/seals/cascade/seal.min.js";var s = document.getElementsByTagName("script");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());
      `}</Safe.script>
      <style jsx>{`
        .digicert,
        .digicert :global(*) {
          height: 40px;
        }

        .digicert {
          padding-right: 10px;
        }
      `}</style>
    </>
  );
};
